import { env } from '../../config/env';
import type { BlogPost, BlogPostInput } from '../../types';
import * as http from './blogService.http';
import * as mock from './blogService.mock';

export interface BlogService {
  fetchPublishedPosts(): Promise<BlogPost[]>;
  fetchAllPosts(): Promise<BlogPost[]>;
  getPost(id: number): Promise<BlogPost>;
  getPostBySlug(slug: string): Promise<BlogPost>;
  createPost(input: BlogPostInput): Promise<BlogPost>;
  updatePost(id: number, input: BlogPostInput): Promise<BlogPost>;
  deletePost(id: number): Promise<void>;
  uploadMedia(file: File): Promise<string>;
}

const mockBlogService: BlogService = {
  fetchPublishedPosts: mock.mockFetchPublishedBlogPosts,
  fetchAllPosts: mock.mockFetchAllBlogPosts,
  getPost: mock.mockGetBlogPost,
  getPostBySlug: mock.mockGetBlogPostBySlug,
  createPost: mock.mockCreateBlogPost,
  updatePost: mock.mockUpdateBlogPost,
  deletePost: mock.mockDeleteBlogPost,
  uploadMedia: mock.mockUploadBlogMedia,
};

const httpBlogService: BlogService = {
  fetchPublishedPosts: http.httpFetchPublishedBlogPosts,
  fetchAllPosts: http.httpFetchAllBlogPosts,
  getPost: http.httpGetBlogPost,
  getPostBySlug: http.httpGetBlogPostBySlug,
  createPost: http.httpCreateBlogPost,
  updatePost: http.httpUpdateBlogPost,
  deletePost: http.httpDeleteBlogPost,
  uploadMedia: http.httpUploadBlogMedia,
};

export const blogService: BlogService = env.useMock ? mockBlogService : httpBlogService;
